import { gql } from 'graphql-tag'
import { getAllowedPostStatuses } from '~/src/utils/wordpress-content'

const buildEventsQuery = ({ includeNonPublished }) => {
  return gql`
    query getEvents {
      events(
        first: 100
        where: {
          stati: [${getAllowedPostStatuses(includeNonPublished)}]
        }
      ) {
        nodes {
          slug
          isFeatured
          events {
            title
            blurb
            url
            startDateTime
            endDateTime
            modality
            format
            location
            backgroundImage {
              node {
                sourceUrl
              }
            }
          }
        }
      }
    }
  `
}

export default buildEventsQuery
